<template>
  <div
    class="c-blogSubArea"
    :class="{ 'c-blogSubArea-app': isFromCoconalaApp }"
  >
    <div class="c-blogSubArea_group">
      <div class="c-blogSubArea_title">
        <span class="c-blogSubArea_titleText">最新ブログ</span>
      </div>
      <div
        v-for="(menusByLatest, index) in blogMenus.menusByLatestList"
        :key="index"
        class="c-blogSubArea_new"
      >
        <nuxt-link :to="`/blogs/${user.id}/${menusByLatest.id}`">{{ $util.truncate(menusByLatest.title, MAX_LATESTS_LENGTH) }}</nuxt-link>
      </div>
    </div>
    <div class="c-blogSubArea_group">
      <div class="c-blogSubArea_title">
        <span class="c-blogSubArea_titleText">アーカイブ</span>
      </div>
      <b-collapse
        class="c-blogSubArea_archive"
        v-for="(menusByYear, index) in blogMenus.menusByYearList"
        :key="index"
        :open="false"
        aria-id="1"
      >
        <a
          class="c-blogSubArea_archiveToggle"
          href="javascript:;"
          slot="trigger"
          slot-scope="props"
          role="button"
          aria-controls="1"
        >
          {{ menusByYear.name }}
          <coconala-icon
            :name="props.open ? 'chevron-down' : 'chevron-right'"
            size="10px"
          />
        </a>
        <ul class="c-blogSubArea_archiveMonthly">
          <li
            v-for="(menusByMonth, index) in menusByYear.menusByMonthList.slice().reverse()"
            :key="index"
          >
            <nuxt-link :to="`/blogs/${user.id}?archive=${$util.dayjs({year: menusByYear.id, month: menusByMonth.id - 1}).format('YYYYMM')}`">
              {{`${menusByMonth.name}(${menusByMonth.count})`}}
            </nuxt-link>
          </li>
        </ul>
      </b-collapse>
    </div>
    <div class="c-blogSubArea_group">
      <div class="c-blogSubArea_title">
        <span class="c-blogSubArea_titleText">ハッシュタグ別</span>
      </div>
      <div
        v-for="(menusByTag, index) in blogMenus.menusByTagList"
        :key="index"
        class="c-blogSubArea_tag"
        :class="{ 'c-blogSubArea_tag-first': index === 0 }"
      >
        <nuxt-link :to="`/blogs/${user.id}?tag=${menusByTag.id}`">{{ `${menusByTag.name}(${menusByTag.count})` }}</nuxt-link>
      </div>
    </div>
  </div>
</template>
<script>
const MAX_LATESTS_LENGTH = 26

// vuex
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'BlogSubArea',
  data() {
    return {
      MAX_LATESTS_LENGTH
    }
  },
  computed: {
    ...mapState('pages/blogs/user', ['blogMenus']),
    ...mapGetters('auth', ['isFromCoconalaApp']),
    user() {
      return this.$store.state.pages.users.user
    }
  }
}
</script>
<style lang="scss" scoped>
.c-blogSubArea {
  &_group {
    display: block;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid $color-border-light;
  }

  &_title {
    margin-bottom: 0.5em;
  }

  &_titleText {
    padding: 0;
    background: none;
    font-weight: bold;
    font-size: 14px;
  }

  &_new {
    margin-bottom: 12px;

    a {
      @include link-effect;

      color: $color-gray-900;
    }
  }

  &_archive {
    margin-bottom: 8px;
  }

  &_archiveToggle {
    @include link-effect;

    color: $color-gray-900;
    font-size: 13px;
  }

  &_archiveMonthly {
    margin-left: 12px;
    font-size: 12px;

    li {
      margin-top: 4px;
    }
  }

  &_tag {
    margin-bottom: 12px;
    font-size: 12px;

    &-first {
      margin-top: 16px;
    }

    a {
      @include link-effect;

      color: $color-gray-900;
    }
  }
}

@media (max-width: $breakpoint-m) {
  .c-blogSubArea {
    padding: 0 16px;
    &-app {
      margin-bottom: 80px;
    }

    &_group {
      margin-top: 16px;
      padding-top: 12px;
      border-top: 1px solid $color-gray-50;
    }

    &_new {
      font-size: 12px;
    }

    &_tag {
      margin-left: 4px;
    }
  }
}
</style>
